import LTR from "@brand-icons/global/social-imessage/social-imessage-ltr.svg";

import { iconFactory } from "../iconFactory";

export const SocialImessageIcon = iconFactory("SocialImessageIcon", LTR);
